import React, { useState } from 'react';
import { supabase } from '../supabaseClient';

const Navbar = ({ onLoginClick, session }) => {
  const [menuOpen, setMenuOpen] = useState(false);

  const handleAuthClick = async () => {
    if (session) {
      await supabase.auth.signOut();
    } else {
      onLoginClick();
    }
    setMenuOpen(false);
  };

  const handleLinkClick = () => {
    setMenuOpen(false);
  };

  return (
    <nav className="navbar">
      <div
        className="nav-logo"
        style={{ cursor: 'pointer' }}
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        title="Go to Top"
      >
        ⛵ Regatta Central Global Series
      </div>

      {/* Hamburger Button — visible only on mobile */}
      <button
        className={`hamburger ${menuOpen ? 'open' : ''}`}
        onClick={() => setMenuOpen(!menuOpen)}
        aria-label="Toggle navigation menu"
        aria-expanded={menuOpen}
      >
        <span></span>
        <span></span>
        <span></span>
      </button>

      {/* Nav links — slide down on mobile when open */}
      <ul className={`nav-links ${menuOpen ? 'nav-open' : ''}`}>
        <li><a href="#events" onClick={handleLinkClick}>Events</a></li>
        <li><a href="#results" onClick={handleLinkClick}>Results</a></li>
        <li><a href="#schedule" onClick={handleLinkClick}>Schedule</a></li>
        <li><a href="#gallery" onClick={handleLinkClick}>Gallery</a></li>
        <li><a href="#store" onClick={handleLinkClick}>Shop 🛒</a></li>
        <li>
          {session ? (
            <div className="nav-user">
              <span className="nav-welcome">
                Welcome, {session.user?.user_metadata?.skipper_name || 'Sailor'}!
              </span>
              <button className="nav-login-btn" onClick={handleAuthClick}>
                Logout
              </button>
            </div>
          ) : (
            <button className="nav-login-btn" onClick={handleAuthClick}>
              Login / Register
            </button>
          )}
        </li>
      </ul>
    </nav>
  );
};

export default Navbar;
